













































import Vue from 'vue';

import AppInfo from '@/components/AppInfo.vue';

export default Vue.extend({
    components: {
        AppInfo,
    },
    data() {
        return {
            prefix: 'https://',
            idp: '',
            solidLoginAttempted: false,
        };
    },
    computed: {
        errorMessage() {
            if (this.solidLoginAttempted && !this.idp)
                return '<strong>Attention!</strong> This field should not be left empty to login with Solid.';

            if (this.prefix === 'http://')
                return '<strong>Attention!</strong> Using http:// is not secure, use at your own risk.';
        },
    },
    methods: {
        loginWithSolid() {
            this.solidLoginAttempted = true;

            if (!this.idp)
                return;

            this.$ui.wrapAsyncOperation(
                async () => {
                    try {
                        await this.$auth.loginWithSolid(this.prefix + this.idp);
                    } catch (error) {
                        throw new Error(
                            'Login with Solid failed, make sure that you introduced the correct ' +
                            'Solid POD url and the POD server is running',
                        );
                    }
                },
                'Logging in...',
            );
        },
        loginOffline() {
            this.$ui.wrapAsyncOperation(
                this.$auth.loginOffline(),
                'Logging in...',
            );
        },
    },
});
